/* batida-v7-info.js: the small interactions of /pages/butiki, /pages/kontakt and /pages/faq (Aleksandra's prototype, 27.09).
   Everything works without it: all boutiques and all questions are in the page, the hours list is complete.
   - Butiki (prototype _44): open / closed and today's hours in Warsaw time, city / type filters, "otwarte teraz",
     photo arrows
   - Kontakt: "W czym możemy pomóc?" highlights the department card and picks its topic in the form
   - FAQ: search in questions and answers, the category list follows the scroll */
(function () {
  'use strict';

  // Warsaw weekday (0 = Monday), whatever the visitor's own time zone is
  function warsawNow() {
    var o = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit' })
        .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    } catch (e) { return null; }
    var days = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
    return { day: days[o.weekday], min: (+o.hour % 24) * 60 + (+o.minute) };
  }
  function toMin(s) { var m = String(s).match(/(\d{1,2})[:.](\d{2})/); return m ? (+m[1]) * 60 + (+m[2]) : null; }

  // ---------- Butiki (prototype _44): open/closed, "Dziś …", filters, "otwarte teraz", photo arrows ----------
  var dashT = function (v) { return String(v || '').trim().replace(/\s*[-–—]\s*/, '-'); }; /* ranges: short hyphen, no spaces */
  var parseH = function (v) {
    var p = String(v || '').split(/\s*[-–]\s*/);
    var a = toMin(p[0]), b = toMin(p[1]);
    return (a === null || b === null) ? null : { a: a, b: b, from: p[0].trim(), to: p[1].trim() };
  };
  document.querySelectorAll('[data-v7i-loc]').forEach(function (root) {
    var now = warsawNow();
    var days = (root.getAttribute('data-days') || '').split(',');
    var T = function (k) { return root.getAttribute('data-t-' + k) || ''; };
    var cards = [].slice.call(root.querySelectorAll('.v7i-lc'));

    if (now) cards.forEach(function (c) {
      var h;
      try { h = JSON.parse(c.getAttribute('data-v7i-h') || 'null'); } catch (e) { h = null; }
      if (!h) return;
      var t = parseH(h[now.day]);
      var open = !!t && now.min >= t.a && now.min < t.b;
      c._open = open;
      var today = c.querySelector('[data-v7i-today]');
      if (today) today.textContent = t ? T('dzis') + ' ' + dashT(h[now.day]) : T('closed-today');
      c.querySelectorAll('.v7i-lc-row').forEach(function (r) {
        r.classList.toggle('is-now', (r.getAttribute('data-days') || '').split(',').indexOf(String(now.day)) > -1);
      });
      var st = c.querySelector('[data-v7i-status]');
      if (!st) return;
      var msg = '';
      if (open) {
        var left = t.b - now.min;
        msg = T('open').replace('[godz]', t.to);
        if (left <= 60 && T('soon')) msg += ' ' + T('soon').replace('[min]', left);
      } else if (t && now.min < t.a) {
        msg = T('today').replace('[godz]', t.from);
      } else {
        for (var i = 1; i <= 7; i++) {
          var d = (now.day + i) % 7, n = parseH(h[d]);
          if (n) { msg = (i === 1 ? T('tomorrow') : T('later').replace('[dzień]', (days[d] || '').trim())).replace('[godz]', n.from); break; }
        }
      }
      if (!msg) return;
      st.querySelector('[data-v7i-status-t]').textContent = msg;
      st.classList.toggle('is-open', open);
      st.classList.toggle('is-shut', !open);
      st.hidden = false;
    });

    // filters: one city / type at a time, plus "otwarte teraz"
    var F = '*';
    var only = root.querySelector('[data-v7i-lf-open]');
    var none = root.querySelector('[data-v7i-lc-none]');
    var wrap = root.querySelector('[data-v7i-lf-open-wrap]');
    if (wrap && now) wrap.hidden = false;
    var apply = function () {
      var n = 0;
      cards.forEach(function (c) {
        var ok = F === '*' || (F.indexOf('city:') === 0 ? c.getAttribute('data-v7i-city') === F.slice(5) : c.getAttribute('data-v7i-typ') === F.slice(4));
        if (only && only.checked && !c._open) ok = false;
        c.hidden = !ok;
        if (ok) n++;
      });
      if (none) none.hidden = n > 0;
    };
    if (only) only.addEventListener('change', apply);

    root.addEventListener('click', function (e) {
      var f = e.target.closest('[data-v7i-lf]');
      if (f) {
        F = f.getAttribute('data-v7i-lf');
        root.querySelectorAll('[data-v7i-lf]').forEach(function (x) { x.setAttribute('aria-pressed', x === f ? 'true' : 'false'); });
        apply();
        return;
      }
      var nv = e.target.closest('.v7i-lc-nav');
      if (nv) slide(nv.parentElement, nv.classList.contains('is-next') ? 1 : -1);
    });

    // photo arrows (and a swipe on phones)
    function slide(ph, dir) {
      var im = [].slice.call(ph.querySelectorAll('.v7i-lc-img'));
      if (im.length < 2) return;
      var i = 0;
      im.forEach(function (x, k) { if (x.classList.contains('is-on')) i = k; });
      i = (i + dir + im.length) % im.length;
      im.forEach(function (x, k) { x.classList.toggle('is-on', k === i); if (k === i) x.loading = 'eager'; });
      var cnt = ph.querySelector('.v7i-lc-cnt');
      if (cnt) cnt.textContent = (i + 1) + '/' + im.length;
    }
    root.querySelectorAll('[data-v7i-slides]').forEach(function (ph) {
      var sx = null;
      ph.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      ph.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) slide(ph, dx < 0 ? 1 : -1);
        sx = null;
      }, { passive: true });
    });
  });

  // ---------- Kontakt: "W czym możemy pomóc?" (highlights the department and picks its topic in the form) ----------
  var depts = document.querySelector('[data-v7i-depts]');
  if (depts) {
    var picks = [].slice.call(document.querySelectorAll('[data-v7i-dept-pick]'));
    var reduceK = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    picks.forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        var id = b.getAttribute('data-v7i-dept-pick');
        var card = null;
        picks.forEach(function (p) { p.setAttribute('aria-pressed', p === b && on ? 'true' : 'false'); });
        depts.classList.toggle('is-sel', on);
        depts.querySelectorAll('[data-v7i-dept]').forEach(function (c) {
          var hit = on && c.getAttribute('data-v7i-dept') === id;
          c.classList.toggle('is-on', hit);
          if (hit) card = c;
        });
        if (!card) return;
        var topic = card.getAttribute('data-topic');
        if (topic) {
          document.querySelectorAll('input[name="contact[temat-wiadomosci]"]').forEach(function (r) { var l = r.parentNode && r.parentNode.querySelector('span'); if (r.value === topic || (l && l.textContent.trim() === topic)) r.checked = true; });
        }
        card.scrollIntoView({ behavior: reduceK ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  // ---------- FAQ ----------
  var faq = document.querySelector('[data-v7i-faq]');
  if (!faq) return;
  var groups = [].slice.call(faq.querySelectorAll('.v7i-faq__g'));
  var links = [].slice.call(faq.querySelectorAll('.v7i-faq__nav a'));
  var qs = [].slice.call(faq.querySelectorAll('.v7i-faq__q'));
  var empty = faq.querySelector('[data-v7i-faq-empty]');
  var norm = function (s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l').replace(/\s+/g, ' ');
  };
  qs.forEach(function (q) { q._t = norm(q.textContent); q._open = q.open; });

  function setCurrent(id) {
    links.forEach(function (a) { a.setAttribute('aria-current', a.getAttribute('href') === '#' + id ? 'true' : 'false'); });
  }

  // search (field in the FAQ head section)
  var input = document.querySelector('[data-v7i-faq-search]');
  if (input) {
    var run = function () {
      var words = norm(input.value).trim().split(' ').filter(Boolean);
      var any = false;
      qs.forEach(function (q) {
        var hit = words.every(function (w) { return q._t.indexOf(w) > -1; });
        q.hidden = !hit;
        if (hit) any = true;
        q.open = words.length && words.join('').length > 2 ? hit : q._open;
      });
      groups.forEach(function (g) {
        var vis = g.querySelector('.v7i-faq__q:not([hidden])');
        g.hidden = !vis;
        var a = faq.querySelector('.v7i-faq__nav a[href="#' + g.id + '"]');
        if (a) a.hidden = !vis;
      });
      if (empty) empty.hidden = any;
    };
    input.addEventListener('input', run);
    input.addEventListener('search', run);
    var form = input.closest('form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      run();
      var first = faq.querySelector('.v7i-faq__q:not([hidden])');
      if (first) first.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    });
  }

  // category list follows the scroll
  if ('IntersectionObserver' in window && groups.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) setCurrent(en.target.id); });
    }, { rootMargin: '-20% 0px -70% 0px' });
    groups.forEach(function (g) { io.observe(g); });
  }
  links.forEach(function (a) { a.addEventListener('click', function () { setCurrent(a.getAttribute('href').slice(1)); }); });

  // 4.10: a link to one question (/pages/faq#q-...) opens that question and brings it into view
  function openHash() {
    var id = location.hash.slice(1);
    try { id = decodeURIComponent(id); } catch (e) {}
    var el = id && document.getElementById(id);
    if (!el || el.tagName !== 'DETAILS' || !faq.contains(el)) return;
    el.open = true; el._open = true;
    el.scrollIntoView({ block: 'start' });
  }
  openHash();
  window.addEventListener('hashchange', openHash);
})();
